import { PrimaryButton, Reveal } from "@/components/ui-bits";

const CapacityCta = () => {
  return (
    <section data-testid="capacity-final-cta" aria-labelledby="capacity-cta-heading" className="bg-white py-16 sm:py-20 lg:py-24">
      <div className="container-30 max-w-3xl">
        <Reveal>
          <p className="eyebrow" data-testid="capacity-cta-eyebrow">Need the Right Transportation Option?</p>
          <h2
            id="capacity-cta-heading"
            data-testid="capacity-cta-headline"
            className="mt-6 text-3xl font-extrabold leading-[1.08] tracking-tight text-[#191c1e] sm:text-4xl lg:text-5xl"
          >
            LET'S FIND THE RIGHT WAY TO MOVE IT.
          </h2>
          <p className="mt-6 text-base leading-relaxed text-[#5f666d] sm:text-lg">
            Tell us what you're moving and we'll help determine the right transportation solution.
          </p>
          <div className="mt-10">
            <PrimaryButton to="/request-a-quote" testid="capacity-cta-button">
              REQUEST A QUOTE
            </PrimaryButton>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default CapacityCta;
